import '@/utils/polyfills'

import { createApp } from './main'
import * as Sentry from '@sentry/vue'
import Config from '@/utils/config'
import { initAnalytics } from '@/utils/analytics'
import { installChunkReloadHandler } from '@/utils/chunkReload'

const { app, router, i18n } = createApp()

// A route chunk that no longer exists means this tab is running a build that has
// been replaced underneath it.
installChunkReloadHandler(router, { message: () => i18n.t('common.updateAvailable') })

if (Config.sentryDsn) {
  Sentry.init({
    app,
    dsn: Config.sentryDsn,
    environment: Config.environment,
    release: Config.appVersion,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
  })
}

// wait until router is ready before mounting to ensure hydration match
router.isReady().then(() => {
  const disableSSR = router.currentRoute.value.matched.some((record) => record.meta.ssr === false)
  if (disableSSR) {
    // The server rendered only the app shell for this route; clear it and do
    // a fresh client mount instead of hydrating against mismatched markup.
    const container = document.getElementById('app')
    if (container) container.innerHTML = ''

    // Also drop the server-injected head teleport (meta tags, config script),
    // otherwise the fresh mount appends a duplicate set.
    const head = document.head
    let inTeleport = false
    for (const node of Array.from(head.childNodes)) {
      const isComment = node.nodeType === Node.COMMENT_NODE
      if (isComment && node.textContent === 'teleport start anchor') inTeleport = true
      const remove = inTeleport
      if (isComment && node.textContent === 'teleport anchor') inTeleport = false
      if (remove) head.removeChild(node)
    }
  }
  app.mount('#app')
  // After mount, so the landing route is the one the visitor actually sees.
  initAnalytics(router)
})
